import { render, staticRenderFns } from "./App.vue?vue&type=template&id=9316c502"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./App.vue?vue&type=style&index=0&id=9316c502&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../Users/zhc/Documents/CF40/CF40-Java/cf40_pc_web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports